import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Button } from "@heroui/react";
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks";
import { apiRoute, linksUrl } from "../../constants/enum";
import { ErrorCard, LoadingCard, MainContainer, NextUITable } from "../../components";
import { COLUMN_ALIGN_TYPE, ROW_ACTION_BTN_TYPE } from "../../components/NextUITable";
import { toast } from "react-toastify";
import ConfirmBox from "../../components/ConfirmBox";
import { setDetailParams, setNewEntryMode } from "../../state/sizeSlice";

const SizeMaster = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);

    // State for confirmation modal
    const [itemToDelete, setItemToDelete] = useState("")

    // Fetch shape data
    const {
        data: sizeData = [],
        isPending,
        isError,
        mutate: filterData
    } = usePost({
        url: apiRoute.size.GetPSize,
        queryKey: "fetchSizeMaster",
    });
    const funLoadData = () => {
        filterData({
            data: {}
        })
    }
    useEffect(() => {
        funLoadData();
    }, [])
    const sortedSizeData = [...sizeData].sort((a, b) => a.Sz_Ord - b.Sz_Ord);


    const onSuccessDelete = () => {
        setItemToDelete("")
        funLoadData()
    };

    // Delete shape mutation
    const { mutate: deletePSize } = usePost({
        url: apiRoute.size.deletePSize,
        queryKey: "deleteSizeMaster",
        onSuccessTasks: onSuccessDelete,
        successMessage: "Size deleted successfully!",
    });

    // Open confirmation box
    const handleDeleteClick = (Sz_Code) => {
        if (!Sz_Code) {
            toast.error("Error: Size Code is missing.");
            return;
        }
        else
            setItemToDelete(Sz_Code)
    };

    const handleConfirmBox = (confirm) => {
        if (confirm && itemToDelete) {
            deletePSize({ data: { Sz_Code: itemToDelete } });
        }
        else {
            setItemToDelete("")
        }
    };

    const handleAddNew = () => {
        dispatch(setNewEntryMode(true));
        dispatch(setDetailParams([]));
        navigate(linksUrl.diamondParamater.size.createSizeMaster);
    };


    const exportColumn = [
        { uid: "Sz_Code", name: "Size Code" }, { uid: "Sz_Name", name: "Size Name" }, { uid: "Sz_Grp", name: "Size Group" }, { uid: "Sz_Ord", name: "Size Order" }
    ]
    const downloadDataFooter = {
        Sz_Code: "", Sz_Name: "", Sz_Grp: "", Sz_Ord: ""
    }

    const columns = [
        { name: "Actions", uid: "actions", align: COLUMN_ALIGN_TYPE.center },
        { name: "Size Code", uid: "Sz_Code", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "Size Name", uid: "Sz_Name", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "Size Group", uid: "Sz_Grp", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "Size Order", uid: "Sz_Ord", sortable: true, align: COLUMN_ALIGN_TYPE.center },
    ];

    const rowActionBtn = [
        {
            icon: <FontAwesomeIcon icon={faEdit} style={{ color: "#379906" }} />,
            onClick: (row) => {
                let obj = {
                    Sz_Code: row.Sz_Code
                };
                dispatch(setDetailParams(obj));
                dispatch(setNewEntryMode(false))
                navigate(linksUrl.diamondParamater.size.createSizeMaster);
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },
        {
            icon: <FontAwesomeIcon icon={faTrash} style={{ color: "#c40c18" }} />,
            onClick: (row) => {
                handleDeleteClick(row.Sz_Code);
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },
    ];

    if (isPending) return <LoadingCard />;
    if (isError) return <ErrorCard />

    return (
        <div>
            <MainContainer pageName="Size" breadcrumbs={["Diamond Parameter", "Size Master"]}>
                <div className="text-right mb-4">
                    <Button size="sm" color="primary" startContent={<FontAwesomeIcon icon={faPlus} />} onPress={handleAddNew}>
                        Add New
                    </Button>
                </div>
                <NextUITable
                    INITIAL_VISIBLE_COLUMNS={["actions", "Sz_Code", "Sz_Name", "Sz_Grp", "Sz_Ord"]}
                    data={sortedSizeData}
                    columns={columns}
                    showAdvanceFilter={false}
                    exportColumns={exportColumn}
                    downloadDataFooter={downloadDataFooter}
                    rowActionBtn={rowActionBtn}
                    downloadFileName="Shape-master-List"
                    id="Sz_Code"

                />
            </MainContainer>

            {itemToDelete && itemToDelete != "" && <ConfirmBox handleConfirmBox={handleConfirmBox} />}
        </div>
    );
};

export default SizeMaster;
